"use client";

import { create } from "zustand";

interface StoreSwitcherState {
    open: boolean;
    /** Seleção obrigatória: o modal não pode ser fechado sem escolher uma loja. */
    required: boolean;
    openModal: (options?: { required?: boolean }) => void;
    close: () => void;
}

/**
 * Estado do modal de troca de loja — UI client-only global (nunca lido no
 * SSR), no mesmo padrão do useAuthModal. Qualquer header abre com
 * `useStoreSwitcher((s) => s.openModal)`; o StoreInit abre com
 * `{ required: true }` quando não há loja definida (bloqueia o fechamento).
 */
export const useStoreSwitcher = create<StoreSwitcherState>()((set) => ({
    open: false,
    required: false,
    openModal: (options) => set({ open: true, required: options?.required ?? false }),
    close: () => set({ open: false, required: false }),
}));
